import { render, staticRenderFns } from "./ModalRetur.vue?vue&type=template&id=6c4de783"
import script from "./ModalRetur.vue?vue&type=script&lang=js"
export * from "./ModalRetur.vue?vue&type=script&lang=js"
import style0 from "./ModalRetur.vue?vue&type=style&index=0&id=6c4de783&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports